import { toClientError as l } from "./to-client-error.js";
const a = /* @__PURE__ */ Symbol("requestContext");
class n {
  init(t) {
    t.clientInterceptors ??= [], t.clientInterceptors.push(async (r) => (r.context[a] = {
      method: r.request.method.toUpperCase(),
      url: r.request.url.toString()
    }, r.next())), t.interceptors ??= [], t.interceptors.push(async (r) => {
      try {
        return await r.next();
      } catch (e) {
        throw l(e, r.context[a], r.signal) ?? e;
      }
    });
  }
}
export {
  n as ErrorNormalizationPlugin
};
//# sourceMappingURL=error-normalization.js.map
